module.exports = __webpack_public_path__ + "static/img/Allo.e8f0438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/nets/Allo.png
// module id = QwuR
// module chunks = 0